import {Component, Input, OnInit} from '@angular/core';
import {CategoriesService, Profile} from '../../core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-profile-stats',
    templateUrl: './statistics.component.html'
})
export class StatisticsComponent implements OnInit {
    constructor(
        private categoriesService: CategoriesService,
        private router: Router
    ) {
    }
    @Input()
    profile: Profile;

    ngOnInit() {
        //get stats for userID
    }

    identifyBadge(): string {
        switch (this.profile) {
            default:
                return 'Pioniero';
        }
    }
}
